$ = require 'jquery'
ModelLoader = require 'app/scripts/db/model-loader'
Payloads = require 'app/scripts/network/payloads'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'

module.exports = class SelectCardPosition

  renderValues: ->
    idBoard = @$('.js-select-board option:selected').val()
    idList = @$('.js-select-list option:selected').val()
    pos = parseInt(@$('.js-select-position option:selected').prop("index"), 10) + 1

    board = @modelCache.get('Board', idBoard)
    boardName = board.get('name')
    list = _.find(board.listList.models, (list) => list.id == idList)

    @$('.js-board-value').text(boardName)

    # It's possible that the board has no open lists, in which case we need to disable
    # some of the controls
    if list?
      listName = list.get('name')
      pos = pos.toString()

      @$('.js-list-value').text(listName)
      @$('.js-pos-value').text(pos)

      @$('.js-select-list,.js-select-position,.js-commit-position,.js-submit').removeAttr('disabled')
    else

      @$('.js-list-value').empty().append $('<i></i>').text(l('no lists'))
      @$('.js-pos-value').empty().append $('<i></i>').text(l('n/a'))

      @$('.js-select-list,.js-select-position,.js-commit-position,.js-submit').attr('disabled', 'disabled')

    return

  updateBoardData: ->
    $selectBoard = @$('.js-select-board')
    idBoardSelected = $selectBoard.find('option:selected').val()

    boardData = {}

    if idBoardSelected == @model.getBoard().id
      @_boardData = @model.getBoard()
      for list in @_boardData.listList.models
        list.cardCount = @_boardData.listList.get(list.id).openCards().length
      @updateListList()
    else if idBoardSelected?
      @$('.js-submit').attr('disabled', 'disabled')
      ModelLoader.loadBoardData idBoardSelected, Payloads.cardsAndListsMinimal
      .then =>
        @_boardData = @modelCache.get('Board', idBoardSelected)
        # updateListList also updates position and rerenders the view
        @updateListList()
      .done()
    return

  updateListList: ->
    $selectBoard = @$('.js-select-board')
    $selectList = @$('.js-select-list').empty()

    idBoardSelected = $selectBoard.find('option:selected').val()

    idListCurrent = @model.getList().id
    if idBoardSelected == @model.getBoard().id
      idListSelected = idListCurrent
    else
      idListSelected = @_boardData.listList.at(0)?.id

    for list in @_boardData.listList.models
      $option = $('<option>').val(list.id).appendTo($selectList)

      desc = if list.id == idListCurrent
        # l is going to return HTML (e.g. it's going to escape things)
        $option.format 'current list', listName: list.get('name')
      else
        $option.text(list.get('name'))

      if list.id == idListSelected
        $option.attr('selected', 'selected')

    @updatePositionList()

  updatePositionList: ->
    $selectList = @$('.js-select-list')
    $selectPos = @$('.js-select-position').empty()
    idListSelected = $selectList.find('option:selected').val()

    if !idListSelected?
      @renderValues()
      return

    listSelected = @_boardData.listList.get(idListSelected) ? @_boardData.listList.at(0)

    sameList = listSelected?.id == @model.getList().id
    maxIndex = @_boardData.listList.get(idListSelected).cardList.length

    if sameList
      currentIndex = @model.getList().openCards().indexOf(@model)
      selectedIndex = currentIndex
      if !@showCurrentPosition
        # if we are copying the card, we should be able to move to any location still
        maxIndex -= 1
    else
      currentIndex = -1
      selectedIndex = maxIndex

    for i in [0..maxIndex]
      indexString = String(i + 1)

      desc = if i == currentIndex
        l('current position', { index: indexString })
      else
        indexString

      pos = if i == 0
        'top'
      else if i == maxIndex
        'bottom'
      else
        listSelected.calcPos(i)

      $option = $('<option>').val(pos).text(desc).appendTo($selectPos)

      if i == selectedIndex
        $option.attr('selected', 'selected')

    @$('.js-pos-value').text String(selectedIndex)

    @renderValues()

    return
